module.exports = __webpack_public_path__ + "img/white-b-disc-b-case-opened.e40f4e74.svg";